import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiEye,
  FiCalendar,
  FiTag,
  FiPaperclip,
  FiSave,
  FiX,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function ContentManager() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [showEditor, setShowEditor] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [content] = useState([
    {
      id: 1,
      title: "Market Outlook Q1 2024",
      type: "Call",
      tags: ["Equity", "Market Analysis"],
      status: "Draft",
      author: "Analyst-001",
      createdDate: "2024-01-15",
      scheduledDate: null,
      attachments: 2,
    },
    {
      id: 2,
      title: "Sector Analysis: Banking",
      type: "Report",
      tags: ["Banking", "Sector"],
      status: "Published",
      author: "Analyst-002",
      createdDate: "2024-01-10",
      scheduledDate: "2024-01-20",
      attachments: 5,
    },
    {
      id: 3,
      title: "Weekly Market Update",
      type: "Call",
      tags: ["Weekly", "Update"],
      status: "Review",
      author: "Analyst-001",
      createdDate: "2024-01-18",
      scheduledDate: "2024-01-22",
      attachments: 1,
    },
  ]);

  const handleCreateNew = () => {
    setShowEditor(true);
  };

  const handleEdit = (contentId) => {
    setShowEditor(true);
    Swal.fire("Edit Content", "Opening content editor...", "info");
  };

  const handleSubmitForReview = (contentId) => {
    Swal.fire({
      title: "Submit for Review?",
      text: "This content will be sent for approval.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Submitted!", "Content has been submitted for review.", "success");
      }
    });
  };

  const filteredContent = content.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.tags.some((tag) => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesStatus = statusFilter === "all" || item.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredContent.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredContent.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                  <div className="content-page-header content-page-headersplit">
                <h5>Research Content Manager</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/research/content-manager">Research</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Content Manager
                  </li>
                </ol>
              </nav>
          
              
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by title or tags..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Draft">Draft</option>
                    <option value="Review">Review</option>
                    <option value="Published">Published</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary" onClick={handleCreateNew}>
                  Create New
                </button>
              </div>
              
              </div>
            </div>

            {/* Content Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Type</th>
                          <th>Tags</th>
                          <th>Status</th>
                          <th>Author</th>
                          <th>Created</th>
                          <th>Scheduled</th>
                          <th>Attachments</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((item) => (
                            <tr key={item.id}>
                              <td style={{ fontWeight: "500" }}>{item.title}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {item.type}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex gap-1 flex-wrap">
                                  {item.tags.map((tag, idx) => (
                                    <span key={idx} className="badge" style={{
                                      background: "#f0f9ff",
                                      color: "#006e82",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                    }}>
                                      {tag}
                                    </span>
                                  ))}
                                </div>
                              </td>
                              <td>
                                <span className={item.status === "Published" ? "badge-active" : item.status === "Review" ? "badge-pending" : "badge-pending"}>
                                  {item.status}
                                </span>
                              </td>
                              <td>{item.author}</td>
                              <td>{item.createdDate}</td>
                              <td>{item.scheduledDate || "-"}</td>
                              <td>{item.attachments}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleEdit(item.id)}
                                    title="Edit"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    title="View"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </div>
                                  {item.status === "Draft" && (
                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={() => handleSubmitForReview(item.id)}
                                      title="Submit for Review"
                                      style={{ fontSize: "12px", padding: "4px 12px" }}
                                    >
                                      Submit
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
